/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Feel_PlaceholderInputs */

const en_body_feel_placeholder = /** @type {(inputs: Body_Feel_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Full`)
};

const es_body_feel_placeholder = /** @type {(inputs: Body_Feel_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Completo`)
};

/**
* | output |
* | --- |
* | "e.g. Full" |
*
* @param {Body_Feel_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const body_feel_placeholder = /** @type {((inputs?: Body_Feel_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Feel_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_body_feel_placeholder(inputs)
	return es_body_feel_placeholder(inputs)
});